<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <cause-form v-if="cause"
          @submit="submit"
          :init-cause="cause"
          :val-errors="valErrors"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import CauseForm from './cause-form'

export default {
  components: { CauseForm },
  data () {
    return {
      cause: null,
      valErrors: []
    }
  },
  methods: {
    async submit (cause) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/causes/${cause.id}`, cause).then(({ data }) => {
        this.$notify({
          message: 'Grund erfolgreich bearbeitet.',
          type: 'success'
        })
        this.$router.push('/causes')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/causes/${this.$route.params.id}`).then(({ data }) => {
      this.cause = data
    })
  }
}
</script>

<style>
</style>
